import { defineStore } from 'pinia';
import apiClient from '@/services/authService';

export const useFilasStore = defineStore('filas', {
  state: () => ({
    filas: [],
    loading: false,
    error: null,
  }),
  actions: {
    async loadFilas() {
      this.loading = true;
      this.error = null;
      try {
        const { data } = await apiClient.get('/api/v1/tickets/queues/');
        this.filas = data;
      } catch (e) {
        this.error = e.response?.data?.detail || e.message;
      } finally {
        this.loading = false;
      }
    },
    async addFila(nome) {
      await apiClient.post('/api/v1/tickets/queues/', { nome });
      await this.loadFilas();
    },
    async editFila(id, nome) {
      await apiClient.put(`/api/v1/tickets/queues/${id}/`, { nome });
      await this.loadFilas();
    },
    async deleteFila(id) {
      await apiClient.delete(`/api/v1/tickets/queues/${id}/`);
      await this.loadFilas();
    },
  },
});
